import "VSS/LoaderPlugins/Css!Agile/Scripts/Common/Components/AgileHubError";
import { ExceptionInfo } from "Agile/Scripts/Models/ExceptionInfo";
import * as AgileControlsResources from "Agile/Scripts/Resources/TFS.Resources.AgileControls";
import * as React from "react";
import { urlHelper } from "VSS/Locations";
import { ZeroData } from "VSSUI/ZeroData";
import { WorkIllustrationUrlUtils, WorkZeroDataIllustrationPaths } from "Presentation/Scripts/TFS/TFS.IllustrationUrlUtils";
import * as Button from "OfficeFabric/Button";

export interface IHubErrorProps {
    exceptionsInfo: ExceptionInfo[];
}

export class HubError extends React.Component<IHubErrorProps, {}> {
    constructor(props: IHubErrorProps) {
        super(props);
    }

    public render(): JSX.Element {
        const exceptionsInfoElement: JSX.Element = (
            <div>
                {
                    this.props.exceptionsInfo.map((exceptionInfo, index) =>
                        (
                            <div key={index}>
                                {this._getErrorsList(exceptionInfo)}
                                {this._getErrorActionButtons(exceptionInfo)}
                            </div>
                        ))
                }
            </div>
        );

        const isSettingsException = this.props.exceptionsInfo.some(e => e.isSettingsException);

        const imagePath = isSettingsException ?
            WorkIllustrationUrlUtils.getIllustrationImageUrl(WorkZeroDataIllustrationPaths.ConfigurationRequired) :
            urlHelper.getVersionedContentUrl("MyExperiences/general-robot-error.png");

        const errorText = isSettingsException ? AgileControlsResources.AgileHub_ConfigurationRequiredTitle : AgileControlsResources.AgileHub_ErrorTitle;

        return (
            <div className="agile-hub-error" >
                <ZeroData
                    imagePath={imagePath}
                    imageAltText={errorText}
                    primaryText={errorText}
                    secondaryText={exceptionsInfoElement}
                />
            </div>
        );
    }

    private _getErrorsList(exceptionInfo: ExceptionInfo): JSX.Element {
        const hasErrorsList: boolean = exceptionInfo.additionalMessages && (exceptionInfo.additionalMessages.length > 0);
        return (
            <div>
                <div>
                    {exceptionInfo.exceptionMessage}
                </div>
                {
                    hasErrorsList && (
                        <ul>
                            {exceptionInfo.additionalMessages.map((e, i) => <li key={`Error${i}`}>{e}</li>)}
                        </ul>
                    )
                }
            </div>
        );
    }

    private _getErrorActionButtons(exceptionInfo: ExceptionInfo): JSX.Element {
        let primaryButton: JSX.Element;
        if (exceptionInfo.primaryLinkHref && exceptionInfo.primaryLinkText) {
            primaryButton = (
                <span className="error-button">
                    <Button.PrimaryButton href={exceptionInfo.primaryLinkHref}>{exceptionInfo.primaryLinkText} </Button.PrimaryButton>
                </span>
            );
        }

        let secondaryButton: JSX.Element;
        if (exceptionInfo.secondaryLinkHref && exceptionInfo.secondaryLinkText) {
            secondaryButton = (
                <span className="error-button">
                    <Button.DefaultButton href={exceptionInfo.secondaryLinkHref}>{exceptionInfo.secondaryLinkText} </Button.DefaultButton>
                </span>
            );
        }

        return (
            <div className="error-footer">
                {primaryButton}
                {secondaryButton}
            </div>
        );
    }
}